export const FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS';
export const ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION';
export const DELETE_SUBSCRIPTIONS ='DELETE_SUBSCRIPTIONS';
export const UPDATE_SUBSCRIPTIONS ='UPDATE_SUBSCRIPTIONS';
export const FETCH_BUNDLES ='FETCH_BUNDLES';
export const ADD_BUNDLE ='ADD_BUNDLE';
export const EDIT_BUNDLE ='EDIT_BUNDLE';
export const DELETE_BUNDLE ='DELETE_BUNDLE';
  